/**
 * Alaska Gift — Product Card Add-to-Cart
 * Handles add-to-cart buttons on product cards (homepage, PDP recommendations, etc.)
 * Depends on: window.AlaskaCart (from cart-drawer.js)
 * Uses event delegation so dynamically injected cards (e.g. Recommendations API) work.
 */

if (!window.__alaskaProductCardsInit) {
window.__alaskaProductCardsInit = true;

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.product-card__add-to-cart');
  if (!btn || btn.disabled) return;

  e.preventDefault();
  e.stopPropagation();
  const id = btn.dataset.productId;
  if (!id) return;
  btn.disabled = true;
  const label = btn.querySelector('span:first-child');
  const productName = btn.closest('.product-card')?.querySelector('.product-card__name')?.textContent?.trim() || 'Item';
  const status = document.getElementById('add-to-cart-status');
  label.textContent = 'Adding...';
  if (status) status.textContent = `Adding ${productName} to cart...`;

  (async () => {
    try {
      if (!window.AlaskaCart) throw new Error('Cart drawer not available');
      await window.AlaskaCart.addAndOpen(id);
      label.textContent = 'Added!';
      if (status) status.textContent = `${productName} added to cart.`;
      setTimeout(() => {
        label.textContent = 'Add to Cart';
        btn.disabled = false;
      }, 1500);
    } catch (err) {
      if (err.name === 'AbortError') {
        label.textContent = 'Add to Cart';
        btn.disabled = false;
        return;
      }
      label.textContent = 'Add to Cart';
      btn.disabled = false;
      if (status) status.textContent = `Failed to add ${productName} to cart.`;
    }
  })();
});
}
